// src/components/animation/animation.styles.ts
import { css } from "lit";
var animation_styles_default = css`
  :host {
    display: contents;
  }
`;

export {
  animation_styles_default
};
